// extracted by mini-css-extract-plugin
export default {"widgetMobileBreakpoint":"568px"};